import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { NouisliderModule } from "ng2-nouislider";

import { AssistantsProfileSearchComponent } from "./assistants-profile-search.component";
import { BooleanDropdownFilterComponent } from "./components/boolean-dropdown-filter/boolean-dropdown-filter.component";
import { ResultItemComponent } from "./components/search-results/result-item/result-item.component";
import { SearchResultsComponent } from "./components/search-results/search-results.component";

@NgModule({
    declarations: [
        BooleanDropdownFilterComponent,
        AssistantsProfileSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [AssistantsProfileSearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class AssistantsProfileSearchModule {
}
